import {pushError} from '@js/actions/errorManagement';

export function patchWorkerErrorReporting() {
    if (typeof window === 'undefined' || typeof window.Worker !== 'function' || window.Worker.__errorReportingPatched) {
        return;
    }

    const NativeWorker = window.Worker;

    const describeUrl = (scriptUrl) => (typeof scriptUrl === 'string' ? scriptUrl : String(scriptUrl));

    class ReportingWorker extends NativeWorker {
        constructor(scriptUrl, options) {
            super(scriptUrl, options);

            this.addEventListener('error', (event) => {
                const error = event.error || new Error(event.message || 'Uncaught worker error');
                pushError(error, {
                    source: 'web-worker',
                    workerUrl: describeUrl(scriptUrl),
                    filename: event.filename,
                    lineno: event.lineno,
                    colno: event.colno
                });
            });

            // Structured-clone deserialization failure on an incoming message.
            this.addEventListener('messageerror', () => {
                pushError(new Error('Worker messageerror (message could not be deserialized)'), {
                    source: 'web-worker',
                    workerUrl: describeUrl(scriptUrl)
                });
            });
        }
    }

    ReportingWorker.__errorReportingPatched = true;
    window.Worker = ReportingWorker;
}
